export const cleanObject = <T extends object>(obj: T): T => {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      // `delete` requires an optional property; the whole point of this helper
      // is to strip keys, so widen to Partial<T> for the removal only.
      delete (obj as Partial<T>)[propName];
    }
  }
  return obj;
};

/**
 * Resolves a dot/bracket path against an object, falling back to `def`.
 *
 * NOTE: the return type is genuinely dynamic (it is whatever sits at `path`),
 * so `any` is deliberate here. `unknown` would be more honest but would force
 * every consumer (e.g. `useCellValue` -> `TextTypeCell`/`CopyableTypeCell`,
 * which render the result directly) to narrow, which is out of scope for a
 * type-only cleanup.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const get = (obj: any, path: string, def: string): any => {
  const fullPath = path
    .replace(/\[/g, ".")
    .replace(/]/g, "")
    .split(".")
    .filter(Boolean);

  return fullPath.every(everyFunc) ? obj : def;

  function everyFunc(step: string) {
    try {
      return !(step && (obj = JSON.parse(obj)[step]) === undefined);
    } catch {
      return !(step && (obj = obj[step]) === undefined);
    }
  }
};
